export default "__VITE_ASSET__m_0bMkjw__"